var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.362,
    height: 11.829,
    viewBox: "0 0 7.362 11.829",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M103.954,5.917l4.688-4.425a.623.623,0,0,0,0-.915l-.411-.388a.716.716,0,0,0-.969,0L101.68,5.458a.627.627,0,0,0,0,.918l5.576,5.264a.716.716,0,0,0,.969,0l.411-.388a.622.622,0,0,0,0-.915Z",
    transform: "translate(-101.48 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon-back.d6690a1a3616b3edb2e6c18df5693aa1.svg";
export { ForwardRef as ReactComponent };